module.exports = __webpack_public_path__ + "static/media/snapology.2e2eed56.png";